module.exports = __webpack_public_path__ + "img/onlineSite.18a8ea24.png";